<div class="qa-jump" *ngIf="questionnaire && questionnaire.questions">
  <div class="qa-jump-search">
    <i class="fa fa-search" aria-hidden="true"></i>
    <input #searchInput type="search" [(ngModel)]="query" [attr.aria-label]="_(KEYS.EDITOR.SEARCH_ELEMENT)"
           placeholder="{{_(KEYS.EDITOR.SEARCH_ELEMENT)}}" (keydown.enter)="onJumpToFirstMatch()">
  </div>
  <div class="qa-jump-list" role="listbox" [attr.aria-label]="_(KEYS.EDITOR.JUMP_TO_ELEMENT)">
    <ng-container *ngFor="let group of getGroups(); trackBy: trackGroup">
      <div *ngIf="group.title" class="qa-jump-group" [class.qa-jump-group-current]="group.current">
        <span>{{group.title}}</span>
        <span *ngIf="group.current" class="qa-jump-current">{{_(KEYS.EDITOR.CURRENT_PAGE)}}</span>
      </div>
      <button *ngFor="let item of group.items; trackBy: trackItem" type="button" class="qa-jump-item" role="option"
              (click)="onJump(item.index)">
        <span class="qa-jump-number">{{item.index + 1}}</span>
        <i class="fa fa-fw" [ngClass]="item.icon" aria-hidden="true"></i>
        <span class="qa-jump-label" [class.qa-jump-untitled]="!item.title" [attr.title]="item.title || item.type">
          {{item.title || item.type}}
        </span>
      </button>
    </ng-container>
    <p *ngIf="!getGroups().length" class="qa-jump-empty">{{_(KEYS.EDITOR.NO_MATCHING_ELEMENTS)}}</p>
  </div>
</div>
